import { takeEvery } from 'redux-saga/effects';
export const MF_REDUX_ACTION_EVENT = '@ovpn-mf-redux-action';
export default function makeMfReduxActionEventSaga(dispatcher, dispatchedActions = []) {
  const matchAction = action => {
    var _action$meta;
    return !((_action$meta = action.meta) != null && _action$meta.dispatcher) && dispatchedActions.includes(action.type);
  };
  function* dispatchEventSaga(action) {
    const eventDetails = {
      detail: {
        action: {
          ...action,
          meta: {
            dispatcher,
            ...action.meta
          }
        }
      }
    };
    const event = new CustomEvent(MF_REDUX_ACTION_EVENT, eventDetails);
    window.dispatchEvent(event);
  }
  return function* () {
    yield takeEvery(matchAction, dispatchEventSaga);
  };
}